import React, { useState, useEffect, useContext } from "react";
import { Theme, useTheme } from '@mui/material/styles'
import { makeStyles } from "@mui/styles";
import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Tabs, Tab, Dialog, DialogContent, Alert, Typography, AlertTitle, DialogActions, Button,
} from "@mui/material";
import Header from "./Header";
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { getHistoryFordatePicker, getPlanningList, getSalesOfficesAndRoutes, saveReleaseDraft } from "../../utils/GetPlanning";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import { useLocalStorage } from "../../componentUtils/LocalStorage";
import Planning from "./Planning";
import Overview from "./Overview";
import Release, { CustomerData, LoadData, PredictionData} from "./Release";
import { getMaterialAdjustments, releasePlanning } from "../../utils/GetPlanning";
import _, { forEach, set } from "lodash";
import { getRouteBuffer } from "src/utils/GetRouteBuffer";
import { GetNotes } from "src/utils/GetCustomer";
import { getWarehouseLocation} from "../../utils/MapsAPI";
import { cs } from "date-fns/locale";
import { PlanInfo, generateLoadDraft } from "./PlanningCalc";
import { SoketContext, DisplayRoleContext } from "src/Context_api";

// interface SalesOffice {
//   salesOffice: string,
//   name: string,
// }
interface DeliveryPlant {
  plant: string,
  name: string,
}

export interface MatDetail {
  materialNum: string;
  description: string;
  denominator: number;
  numerator: number;
}

export interface PlanningItemDetail {
  material_num: string;
  consignment: number;
  init_inventory: number;  
  last_inventory: number;
  average_consumption: number;
  average_trend: number;
  average_based_on_rec: number;  
  average_data: string;
  current_inventory: number;
  refill_qty: number;
}

export interface ExpectedFillMaterial{
  material_num:	string;
  consignment: number;
  average_consumption: number;
  quantity: number;
}

export interface ExpectedFill{
  fillDt: Date;
  route: string;
  fillMaterials: ExpectedFillMaterial[];
}
export interface FastMovingStop{
  client_id: number;
  sales_org: string;
  customer_num: string;
  equipment_num: string;
  load_date: Date;
  next_visit_dt_act: Date;
  expectedFills:ExpectedFill[]|undefined;
}

export interface PlanningItem {
  customerNotes: any[];
  cancelVisitDates: any[];
  customerNum: string;
  equipmentNum: string;
  equipmentStatus: string;
  assetNum: string;
  location: string;
  model: string;
  bank: string;
  status: string;
  currentStatus:string;
  activity: string;
  routeAct: string;
  routePlan: string;
  latitude: number;
  longitude: number;
  lastDelivery: Date;
  lastInventoryUpdate: Date;
  lastFillRate: number;
  expectedFills: ExpectedFill[];
  nextDeliveryPlan: string;
  nextDeliveryAct: string;
  schedulingMethod: string;
  name: string;
  street: string;
  city: string;
  accessDays: string;
  prefDays: string;
  salesDays: string;
  suspended: string;
  criticalMaterialInventory: number;
  criticalMaterialConsumption: number;
  criticalMaterialNum: string;
  materialInventory: number;
  materialConsumption: number;
  online: string;
  dexErrors: boolean;
  details: PlanningItemDetail[];
  dri: number;
  pfr: number;
  pfrc: number;
  pfu: number;
  numSalesDays: number;
  cap: number;
  inv: number;
  ftc: boolean;
  sort: string;
  loading: boolean;
  id: number;
  guid:string;
  sheduled:any;
  isFKMissed:boolean;
  seasonalityConfig?: any;
  selMnthStlmts?:  number;
  settlementThreshold?: number;
  ishistory?: boolean;
  notes?: any;
  txVisitPlanningReview?: any;
}

export interface ReleaseDraft {
  sales_org: string;
  sales_office: string;
  delivering_plant: string;
	route: string;
  load_date: Date;
	customer_num: string;
	equipment_num: string;
  ftc: boolean;
  online:boolean;
  zeroload:boolean;
	draft_load_type: DraftLoadType;
	material_num: string;
  qty:number;
  bfr_adj_qty:number;
  adj_cs:number;
  clear_load: boolean;
	extra_cs:number;
  total_cs:number;
  consignment:number,
  average_consumption:number,
  refill_quantity:number,
  delivery_type:number,
  conv_factor:number
}

export enum DraftLoadType {
  TRUCKLOAD='TRUCKLOAD',
  CUSTOMERLOAD='CUSTOMERLOAD'
}

export interface PlanningState {
  isLoaded: boolean,
  isLoading: boolean,
  planMode: string,
  bufferStockFactor: number,
  plants:any,
  routes: any,
  selectedDeliveryPlant: string,
  selectedRoute: string,
  filteredRoutes: any,
  planningData: PlanningItem[],
  planningDataActual: PlanningItem[],
  warehouseLocation:any,
  planningDate: Date,
  activityIndex: number,
  matDetails: MatDetail[],
  releaseDraft:ReleaseDraft[],
  isReleaseDraftSaved: boolean,
  isRelaseDraftModified:boolean,
  confirmed:number,
  overdue: number,
  scheduled: number,
  banked: number,
  cases: number,
  act_cases: number,
  extras: number,
  total_eaches: number,
  routeInfoTrack?: any,
  enableReviewFeature?: any
  hsReview?: ReviewHeaderStats
}

export interface DetailState {
  planningItem: PlanningItem | null,
  matDetails: MatDetail[],
  settlementData: any
}

interface HeaderStats {
  confirmed:number;
  overdue: number,
  scheduled: number,
  banked: number,
  cases: number,
  act_cases: number,
  extras: number,
  total_eaches: number,
}

interface ReviewHeaderStats {
  reviewConfirmed:number;
  reviewOverdue: number,
  reviewScheduled: number,
  reviewBanked: number,
  reviewCases: number,
  reviewActCases: number,
  reviewExtras: number,
  reviewEaches: number
}

export interface Summary {
  materialNum: string;
  description: string;
  totalUnits: number;
  adjustedUnits: number;
  totalCS: number;
  totalReleaseCS: number;
  matAdjExtaCS: number;
  act_cases: number,
  adjstCS: number;
  clearLoad: boolean;
}

export interface ReleaseData {
  plant: string;
  route: string;
  loadDate: Date;
  customerList: CustomerData[];
  loadList: LoadData[];
}

export interface ReleaseDraftData {
  salesOrg: string;
  salesOffice:string;
  deliveryPlant: string;
  route: string;
  loadDate: Date;
  truckLoadState: ReleaseDraft[];
  customerLoadState: ReleaseDraft[];
}

export interface ClearDraftData {
  salesOrg: string;
  plant: string;
  route: string;
  loadDate: Date;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

export default function RoutePlanning() {
  const {broadcast,postmessage,uuid,is_active,setActive,postSoket}:any = useContext(SoketContext);
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [Sessionlist, setSessionlist] = useState([]); 
  const [futureSusWrnDay, setFutureSusWrnDay] = useState('');
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState('planning');
  const tabs = [
    { value: 'planning', label: "Route Planning" },
    { value: 'overview', label: "Delivery Plant & Route Overview" },
    { value: 'release', label: "Adjust and Release" }    
  ];

  const today = new Date().setHours(12,0,0,0);
  const tomorrow = new Date(today.valueOf() + (1000 * 3600 * 24));
  const [autoSaveState, setAutoSaveState] = React.useState<any>();
  const [state, setState] = React.useState<PlanningState>({
    isLoaded: false,
    isLoading: false,
    planMode: "",
    bufferStockFactor: 1,
    plants:[],
    routes: [],
    selectedDeliveryPlant: "",
    selectedRoute: "",
    filteredRoutes: [],
    planningData: [],
	  warehouseLocation: [],
    planningDataActual: [],
    planningDate: tomorrow,
    activityIndex: -1,
    matDetails: [],
    releaseDraft:[],
    isReleaseDraftSaved: false,
    isRelaseDraftModified:false,
    confirmed: 0,overdue: 0, scheduled: 0, banked: 0, cases: 0, act_cases:0, extras: 0, total_eaches:0,
    hsReview:{
      reviewConfirmed: 0,
      reviewOverdue: 0,
      reviewScheduled: 0,
      reviewBanked: 0,
      reviewCases: 0,
      reviewActCases: 0,
      reviewExtras: 0,
      reviewEaches: 0
    }
  });
  const [planningDataState, setPlanningDataState] = React.useState<any>();
  const [planningActDataState, setPlanningActDataState] = React.useState<any>();
  const [bufferValue, setBufferValue] = React.useState<any>([]);
  const [routesSelected,setRoutesSelected]=useState([]);
  const [alertClearRoute,setAlertClearRoute]=useState(false);
  const [routeEvent,setRouteEvent]=useState<any>('');
  const [salesOrgEvent,setSalesOrgEvent]=useState<any>('');

  const [refresh, setRefresh] = React.useState<any>(false)

  const [datePickerData, SetDatePickerData] = React.useState([])
  const [sessionAlert, setAlert] = useState({
    is_disable:false,
    message:""
  });



   // Socket
   useEffect(() => {
    if (broadcast) {
      if (broadcast.event === 'is_planning') {
        let b_params: any = broadcast?.message.split(';');
          if (salesOrg.toString() == b_params[0] &&
            state.selectedDeliveryPlant == b_params[1] &&
            state.selectedRoute == b_params[2] &&
            new Date(state.planningDate).toISOString()?.split("T")[0] == b_params[3]
            && b_params[4] != uuid
          ) {
            setAlert({
              is_disable:true,
              message:"This page has been activated by another session; please refresh"
            })
            //setActive(true)
          }
      }
      if (broadcast.event === 'is_seasonality') {
        setAlert({
          is_disable:true,
          message:"This page has been activated by another session; please refresh"
        })
      }

      
    }

  }, [broadcast])




  
  let bufferedValue:any[] = bufferValue;
  const handleTabsChange = (event: any, value: string) => {
    setCurrentTab(value);
  };

  const saveAutoSaveState = (autoSaveObj: any) => {
   // console.log(autoSaveObj);
    setAutoSaveState({...autoSaveState,...autoSaveObj,route:state.selectedRoute,planningDateStr:state.planningDate.toISOString().split('T')[0]});
    };

  const setSessionCustomer=(newValue:[])=>{
    
    if(newValue.length>0){
      setSessionlist(oldArray => [...oldArray,...newValue] );
    }
    
  }
  // Method to fetch closet date.

  function getPreviousSheduledList (dates:any,target:any){
    let prevDate='1000-01-01';
     if(dates?.length==0){
       return prevDate
     }
     for (let i = 0; i < dates?.length; i++) {
       let dateItems = dates[i];
     if(new Date(dateItems)<new Date(target)){
       if(new Date(prevDate)<new Date(dateItems)){
         prevDate=dateItems;
       }
     }
   }
    return  new Date(prevDate).toISOString().split('T')[0];
   }

    const setReleaseDraft = (releaseDraft:ReleaseDraft[],planningdata?:PlanningItem[]) => {
      
      let extraCSSet = new Map<string, number>();
      let isZeroLoadActive =false;
      if(releaseDraft&&releaseDraft.length>0){
      releaseDraft.map(draft => {
        isZeroLoadActive=draft.zeroload;
        if(draft.draft_load_type==DraftLoadType.TRUCKLOAD&&draft.extra_cs!=0){
          extraCSSet.set(draft.material_num,draft.extra_cs);
        }
        if(planningdata&&planningdata.length>0){
        if(draft.draft_load_type==DraftLoadType.CUSTOMERLOAD){
          const planningItemIndex =planningdata.findIndex(planningItem => planningItem.customerNum === draft.customer_num);
          if(planningItemIndex>=0){
            const planningDetailIndex =planningdata[planningItemIndex].details.findIndex(planningDetailItem => planningDetailItem.material_num === draft.material_num);
            if(planningDetailIndex>=0){
             // console.log('refill_qty error',planningdata[planningItemIndex])
            planningdata[planningItemIndex].details[planningDetailIndex].refill_qty = draft.qty;
            }
          }
        }
      }
      });
    }
    return{adjstCases:extraCSSet,planningdata:planningdata,isZeroLoadActive:isZeroLoadActive}
    };

    const setReleaseDraftState = (releaseDraft: ReleaseDraft[], isReleaseDraftSaved:boolean) => {
      if(isReleaseDraftSaved){
          setState({...state, planningDataActual:_.cloneDeep(planningActDataState),releaseDraft: releaseDraft,isRelaseDraftModified: true, isReleaseDraftSaved:true});  
      }else{
        const planningDataActual =_.cloneDeep(state.planningDataActual);
        setPlanningDataState(planningDataActual);
        setPlanningActDataState(planningDataActual);
        setState({...state, releaseDraft: releaseDraft,planningData:planningDataActual,planningDataActual:planningDataActual,isReleaseDraftSaved:true});
      }
    }

    // const setReleaseDraftSaveState = (isRelaseDraftModified:boolean, isReleaseDraftSaved:boolean) => {
    //   setState({...state, isRelaseDraftModified: isRelaseDraftModified,isReleaseDraftSaved:isReleaseDraftSaved});
    // }
   
  const setReleaseDraftSaveState = (isRelaseDraftModified:boolean, isReleaseDraftSaved:boolean,hs?:any,planningDataobj?:any) => {
    if(planningDataobj){
     // console.log(planningDataobj)
      let panningObj= _.cloneDeep(state.planningData);

    

      let index = panningObj.findIndex(x => x.customerNum ===planningDataobj.customerNum);
      if(index>=0){

       let planningDataobjIndex= panningObj[index].details.findIndex(x => x.material_num ===planningDataobj.planningItems.material_num);
       if(planningDataobjIndex>=0){

        panningObj[index].details[planningDataobjIndex].refill_qty=planningDataobj.planningItems.refill_qty;
       }
      }

      setState({...state,...hs, isRelaseDraftModified: isRelaseDraftModified,isReleaseDraftSaved:isReleaseDraftSaved,planningData:panningObj});
    }
    else{
      setState({...state,...hs, isRelaseDraftModified: isRelaseDraftModified,isReleaseDraftSaved:isReleaseDraftSaved});
    }

   
  }

  const clearDraft = () => {
    const planningDataActual =_.cloneDeep(state.planningDataActual);
    let newAutoSaveStateInstance={...autoSaveState,adjstCases: new Map};
    const hs = calcHeaderStats(planningDataActual, state.planningDate, state.matDetails, state.bufferStockFactor,newAutoSaveStateInstance);
    setPlanningDataState(planningDataActual);
    const newStateInstance ={...state,planningData:planningDataActual, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, isReleaseDraftSaved:true};
    //setState(newStateInstance);
    newAutoSaveStateInstance={...newAutoSaveStateInstance, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches};
    setAutoSaveState(newAutoSaveStateInstance);
    handleCSUpdate(hs);
    saveDraft(newStateInstance,newAutoSaveStateInstance);
  }

  const saveDraft = (stateObj?:any,autoSaveStateObj?:any) => {
    const stateInstance=stateObj?stateObj:_.cloneDeep(state);
    const autoSaveStateInstance=autoSaveStateObj?autoSaveStateObj:_.cloneDeep(autoSaveState);
    const bufferValues =  bufferValue?.length > 0 ? bufferValue : bufferedValue ?? [];
    const isLoadResetActive:boolean = autoSaveStateInstance&&autoSaveStateInstance.isLoadResetActive?autoSaveStateInstance.isLoadResetActive:0;
    const planInfo:PlanInfo= {
      sales_org: salesOrg,
      sales_office: stateInstance.selectedDeliveryPlant,
      delivering_plant: stateInstance.selectedDeliveryPlant,
      route: stateInstance.selectedRoute,
      planningDate: stateInstance.planningDate,
      planMode:stateInstance.planMode,
      bufferValues:bufferValues,
      planningData:stateInstance.planningData,
      matDetails:stateInstance.matDetails,
      adjestedMaterials:autoSaveStateInstance?.adjestedMaterials,
      adjstCases:autoSaveStateInstance?.adjstCases,
      zeroload:isLoadResetActive
    }
    const releaseDraftData:any= generateLoadDraft(planInfo); 
    let releaseDraftState:ReleaseDraft[]=Object.assign(releaseDraftData.truckLoadState).concat(Object.assign(releaseDraftData.customerLoadState));
    setState({...stateInstance, releaseDraft: releaseDraftState,isRelaseDraftModified: true, isReleaseDraftSaved:true});
    //send this data to save release draft api
   
    if(sessionAlert.is_disable!=true){
    saveReleaseDraft(salesOrg.toString(),releaseDraftData, stateInstance.planMode).then((v: any) => {
      if (v) {
        if (v === "S") {
          //let releaseDraftState:ReleaseDraft[]=truckLoadState.concat(customerLoadState);
          //setReleaseDraftState(releaseDraftState,true);
          //setState({...stateObj, releaseDraft: releaseDraftState,isRelaseDraftModified: true, isReleaseDraftSaved:true});
        } else if (v === "E") {
          //setErrorMessage("Unknown error submitting the draft");
          //console.error(errorMessage);
        } else {
          //setErrorMessage(v);
          console.warn(v);
        }
      }
    });
  }
  
  };

  const saveDraft2 = (stateObj?:any,autoSaveStateObj?:any) => {
   // console.log("Clicked Save as Draft") ;

    const truckLoadState:ReleaseDraft[]=[];
    const customerLoadState:ReleaseDraft[]=[]; 
    //const summary: Summary[] = releasestate.adjustedSummary;
    //const planningItems: PlanningItem[]=releasestate.data;
    const stateInstance=stateObj?stateObj:_.cloneDeep(state);
    const autoSaveStateInstance=autoSaveStateObj?autoSaveStateObj:_.cloneDeep(autoSaveState);

    const planMode = stateInstance.planMode;

    const planningDate =stateInstance.planningDate;
    const selectedRoute =stateInstance.selectedRoute;
    // const selectedSalesOffice = stateInstance.selectedSalesOffice;
    const selectedDeliveryPlant = stateInstance.selectedDeliveryPlant;
    const isLoadResetActive:boolean = autoSaveStateInstance&&autoSaveStateInstance.isLoadResetActive?autoSaveStateInstance.isLoadResetActive:0;
    const planningData =stateInstance.planningData;
    const matDetails =stateInstance.matDetails;
    const adjestedMaterials =autoSaveStateInstance?.adjestedMaterials;
    const adjstCases = autoSaveStateInstance?.adjstCases;

    const {summary,planningItems} = generateSummary(planningDate,planMode,planningData,matDetails,adjestedMaterials,adjstCases);
    //console.log(JSON.stringify(summary));

    summary.forEach(summaryItem => {
      const draftItem: ReleaseDraft = {
        sales_org: salesOrg,
        sales_office: selectedDeliveryPlant,
        delivering_plant: selectedDeliveryPlant,
        route: selectedRoute,
        load_date: planningDate,
        customer_num: '' ,
        equipment_num: '',
        ftc: false,
        online:false,
        zeroload:isLoadResetActive,
        draft_load_type: DraftLoadType.TRUCKLOAD,
        material_num: summaryItem.materialNum,
        qty:summaryItem.totalUnits,
        bfr_adj_qty:summaryItem.adjustedUnits,
        adj_cs:summaryItem.matAdjExtaCS,
        extra_cs:summaryItem.adjstCS,
        clear_load:summaryItem.clearLoad,
        total_cs:summaryItem.totalReleaseCS,
        consignment:0,
        average_consumption:0,
        refill_quantity:0,
        delivery_type:0,
        conv_factor:getMatConv(state.matDetails,summaryItem.materialNum)
      };
      truckLoadState.push(draftItem);
    });

    planningItems.forEach(planningItem => {
      var deliveryType = 0;
      if (planningItem.activity === "PREM") {
        deliveryType = 1;
      }
      if (planningItem.activity === "DISP") {
        deliveryType = 2;
      }
      // equipment is in NOPH already? Don't create ticket and backend flips it back to NORM
      if (planningItem.equipmentStatus === "NOPH") {
        deliveryType = 0;
      }

      planningItem.details.forEach(planningItemDetail => {
        const draftItem: ReleaseDraft = {
          sales_org: salesOrg,
          sales_office: selectedDeliveryPlant,
          delivering_plant: selectedDeliveryPlant,
          route: selectedRoute,
          load_date: planningDate,
          customer_num: planningItem.customerNum ,
          equipment_num: planningItem.equipmentNum,
          ftc: planningItem.ftc,
          online:planningItem.online?true:false,
          zeroload:isLoadResetActive,
          draft_load_type: DraftLoadType.CUSTOMERLOAD,
          material_num: planningItemDetail.material_num,
          qty:planningItemDetail.refill_qty,
          bfr_adj_qty:0,
          adj_cs:0,
          extra_cs:0,
          clear_load:false,
          total_cs:0,
          consignment:planningItemDetail.consignment,
          average_consumption:planningItemDetail.average_consumption,
          refill_quantity:planningItemDetail.refill_qty,
          delivery_type:deliveryType,
          conv_factor:getMatConv(state.matDetails,planningItemDetail.material_num)
        };
        customerLoadState.push(draftItem);
      });
    });

    const releaseDraftData: ReleaseDraftData = {
      salesOrg: salesOrg,
      salesOffice:selectedDeliveryPlant,
      deliveryPlant: selectedDeliveryPlant,
      route: selectedRoute,
      loadDate: planningDate,
      truckLoadState: truckLoadState,
      customerLoadState: customerLoadState
    };

    
    let releaseDraftState:ReleaseDraft[]=truckLoadState.concat(customerLoadState);
    //setReleaseDraftState(releaseDraftState,true);
    
  
    let states=stateObj?stateObj:stateInstance
    setState({...states, releaseDraft: releaseDraftState,isRelaseDraftModified: true, isReleaseDraftSaved:true});
    //send this data to save release draft api
    if(sessionAlert.is_disable!=true){
    saveReleaseDraft(salesOrg.toString(),releaseDraftData, planMode).then((v: any) => {
      if (v) {
        if (v === "S") {
          //let releaseDraftState:ReleaseDraft[]=truckLoadState.concat(customerLoadState);
          //setReleaseDraftState(releaseDraftState,true);
          //setState({...stateObj, releaseDraft: releaseDraftState,isRelaseDraftModified: true, isReleaseDraftSaved:true});
        } else if (v === "E") {
          //setErrorMessage("Unknown error submitting the draft");
          //console.error(errorMessage);
        } else {
          //setErrorMessage(v);
          console.warn(v);
        }
      }
    });
  }
  
  };
    

    const generateReleaseData = () => {
     const {summary,planningItems} = generateSummary(state.planningDate,state.planMode,state.planningData,state.matDetails,autoSaveState.adjestedMaterials,autoSaveState.adjstCases);


      // predictive data
      var customerList = new Array<CustomerData>();
      const sourceData: PlanningItem[] = planningItems;
      for (var i = 0; i < sourceData.length; i++) {
        const pli = sourceData[i];
        var predictionList = new Array<PredictionData>();
        // for (var j = 0; j < pli.details.length; j++) {
        //   const item = pli.details[j];
        //   const predictionData: PredictionData = {
        //     materialNum: item.material_num,
        //     consignment: item.consignment,
        //     averageSales: item.average_consumption,
        //     totalEA: item.refill_qty,
        //     convFactor: getMatConv(state.matDetails,item.material_num),
        //   };
        //   predictionList.push(predictionData);
        // }
        var deliveryType = "0";
        if (pli.activity === "PREM") {
          deliveryType = "1";
        }
        if (pli.activity === "DISP") {
          deliveryType = "2";
        }
        // equipment is in NOPH already? Don't create ticket and backend flips it back to NORM
        if (pli.equipmentStatus === "NOPH") {
          deliveryType = "0";
        }
        const customerNotes:any = [];
        // if(pli.customerNotes?.length > 0) {
        //   const cn = pli.customerNotes
        //   cn.map((item: any) => {
        //     const date = new Date(item?.validUntilDt);
        //     const today = new Date();
        //     const isValid = date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
        //     if (!item?.isDeleted && isValid) {
        //       customerNotes?.push(item);
        //     }
        //   });
        // }
        const customerData: CustomerData = {
          route: pli.routeAct,
          customerNum: pli.customerNum,
          equipmentNum: pli.equipmentNum,
          predictionList,
          deliveryType,
          customerNotes
        };
        customerList.push(customerData);
      }

      // load data
      var loadList = new Array<LoadData>();
      //const summary: Summary[] = state.adjustedSummary;
      for (var n = 0; n < summary.length; n++) {
        const sum = summary[n];
        const loadData: LoadData = {
          materialNum: sum.materialNum,
          loadCS: sum.totalReleaseCS,
          convFactor: getMatConv(state.matDetails,sum.materialNum),
        };
        loadList.push(loadData);
      }

      const releaseData: ReleaseData = {
        plant: state.selectedDeliveryPlant,
        route: state.selectedRoute,
        loadDate: state.planningDate,
        customerList,
        loadList,
      };

    //}

    return releaseData;

    }

    
  const getMatConv = (matDetails:any,matnr: string): number => {
    var factor = 1;
    const matDetail:any = matDetails.find((elem:any) => elem.materialNum === matnr);
    if (matDetail && matDetail.denominator && matDetail.numerator) {
      factor = matDetail.denominator / matDetail.numerator;
    }
    return factor;
  };


    const generateSummary = (planningDate:Date,planMode:string, planningData: PlanningItem[],matDetails: MatDetail[],adjestedMaterials:any,adjstCases:any) => {
      const PM_DYN = "DYNAMIC";
      const PM_STATIC = "STATIC";
      const planningDataObj =_.cloneDeep(planningData);
      const planningItems = planningDataObj.filter(
        (elem) => elem.status === "S" && elem.nextDeliveryAct === planningDate.toISOString().split("T")[0]
      );
      var summary: Summary[] = [];
     // if (planMode != PM_DYN) {
        summary = updateSummary(planningItems, matDetails);
     // }
      summary = handleAdjustedMaterials(summary,adjestedMaterials,adjstCases);
      return {summary,planningItems};

    }

    const updateSummary = (items: PlanningItem[], matDetails: MatDetail[]): Summary[] => {
      var summaryMap = new Map<string, number>();
      const bufferMeta: any = {};
      for (var i = 0; i < items.length; i++) {
        const item = items[i];
        for (var j = 0; j < item.details.length; j++) {
          const mat = item.details[j];
          if (item.activity === "NORM" || item.activity === "INIT" || item.equipmentStatus === "NOPH") {
            if (summaryMap.has(mat.material_num)) {
              var totalUnits = summaryMap.get(mat.material_num) || 0;
              totalUnits += mat.refill_qty;
              summaryMap.set(mat.material_num, totalUnits);
              if(item?.ftc){
                let ftcRefillQty = bufferMeta[mat.material_num]?.ftcRefilQty ?? 0
                ftcRefillQty += mat.refill_qty
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  ftcRefilQty : ftcRefillQty
                }
              }else if(item?.online){
                let online = bufferMeta[mat.material_num]?.onlineRefilQty ?? 0
                online += mat.refill_qty
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  onlineRefilQty : online
                }
              }else{
                let offline = bufferMeta[mat.material_num]?.offlineRefilQty ?? 0
                offline += mat.refill_qty
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  offlineRefilQty : offline
                }
              }
              
            } else {
              summaryMap.set(mat.material_num, mat.refill_qty);
              bufferMeta[mat.material_num] = {
                material_num: mat.material_num,
                material_num_short: parseInt(mat.material_num).toString(),
              };
              if(item?.ftc){
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  ftcRefilQty : mat.refill_qty
                }
              }else if(item?.online){
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  onlineRefilQty : mat.refill_qty
                }
              }else{
                bufferMeta[mat.material_num] = {
                  ...bufferMeta[mat.material_num],
                  offlineRefilQty : mat.refill_qty
                }
              }
            }
          }
        }
      }
      // console.log("🚀 ~ file: Release.tsx ~ line 282 ~ Release ~ bufferMeta", bufferMeta);
  
      const matnrs = Array.from(summaryMap.keys());
      var summaryItems = new Array<Summary>();
      for (var i = 0; i < matnrs.length; i++) {
        const matnr = matnrs[i];
        const matDetail = matDetails.find((elem) => elem.materialNum === matnr);
        var matDesc = "";
        const refillQty = summaryMap.get(matnr) || 0;
        const units =  Math.ceil(refillQty);
        const adjusted: number = calculateAdjustedLoad(bufferMeta[matnr]);
        var cs = 0;
        var actcs = 0;
        if (matDetail) {
          matDesc = matDetail.description;
          cs = Math.ceil((adjusted / matDetail.denominator) * matDetail.numerator);
          actcs = Math.ceil((units / matDetail.denominator) * matDetail.numerator);
        }
        if (cs === 0) {
          cs = 1;
          actcs = 1;
        }
        if (cs < 0) {
          cs = 0;
          actcs = 0;
        }
        var summaryItem: Summary = {
          materialNum: matnr,
          description: matDesc,
          totalUnits: refillQty,
          adjustedUnits: adjusted,
          totalCS: cs,
          act_cases: actcs,
          totalReleaseCS: cs,
          matAdjExtaCS: 0,
          adjstCS: 0,
          clearLoad: false,
        };
        summaryItems.push(summaryItem);
        //console.log("🚀 ~ file: Release.tsx ~ line 315 ~ Release ~ summaryItem", summaryItem);
      }
      summaryItems.sort(function (a, b) {
        var textA = a.description.toUpperCase();
        var textB = b.description.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      return summaryItems;
    };



    const handleAdjustedMaterials = (
      summary?: any,
      adjustedMaterials?: any,
      extraAdjustmentCases?: any
    ) => {
      const summaryObj: Summary[] = _.cloneDeep(summary);
      let newSummary: Summary[] = summaryObj;

      if (adjustedMaterials && adjustedMaterials.length > 0) {
        newSummary = summaryObj.map((item: any, row: any) => {
          const summaryItem: Summary = {
            materialNum: item.materialNum,
            description: item.description,
            totalUnits: item.totalUnits,
            adjustedUnits: item.adjustedUnits,
            totalCS: item.totalCS,
            act_cases: item.act_cases < 0 ? 0 : item.act_cases,
            totalReleaseCS: item.totalCS < 0 ? 0 : item.totalCS,
            matAdjExtaCS: 0,
            adjstCS: 0,
            clearLoad: false,
          };
          const adjustedItem = adjustedMaterials.find((mat: any) => item.materialNum === mat.material_num);
          let adjstCSVal = extraAdjustmentCases.get(item.materialNum);
          adjstCSVal = adjstCSVal ? adjstCSVal : 0;
          if (adjustedItem) {
            //if(isDateWithIn(adjustedItem.start_date,adjustedItem.end_date,props.data.planningDate)){
            if (adjustedItem.clear_load) {
              summaryItem.clearLoad = true;
              summaryItem.matAdjExtaCS = 0;
              summaryItem.totalCS = 0;
              summaryItem.totalReleaseCS = 0;
            } else {
              summaryItem.matAdjExtaCS = adjustedItem.quantity;
              summaryItem.adjstCS = adjstCSVal;
              //const updatedTotalCS =item.totalCS+adjustedItem.quantity;
              //summaryItem.totalCS=updatedTotalCS>=0?updatedTotalCS:0;
              summaryItem.totalCS = item.totalCS;
              let releaseCSTotal = item.totalCS + adjstCSVal + adjustedItem.quantity;
              if (releaseCSTotal < 0) {
                releaseCSTotal = 0;
              }
              summaryItem.totalReleaseCS = releaseCSTotal;
            }
            //}
          }
          return summaryItem;
        });
  
        for (const adjustedItem of adjustedMaterials) {
          let adjstCSVal = extraAdjustmentCases.get(adjustedItem.materialNum);
          adjstCSVal = adjstCSVal ? adjstCSVal : 0;
          if (!summaryObj.some((summaryItem) => adjustedItem.material_num === summaryItem.materialNum)) {
            let totalReleaseCS = !adjustedItem.clear_load ? adjustedItem.quantity + adjstCSVal : 0;
            if (totalReleaseCS < 0) {
              totalReleaseCS = 0;
            }
            newSummary.push({
              materialNum: adjustedItem.material_num,
              description: adjustedItem.description.description,
              totalUnits: 0,
              adjustedUnits: 0,
              totalCS: 0,
              act_cases:0,
              totalReleaseCS,
              matAdjExtaCS: !adjustedItem.clear_load ? adjustedItem.quantity : 0,
              adjstCS: adjstCSVal ? adjstCSVal : 0,
              clearLoad: adjustedItem.clear_load,
            });
          }
        }
        newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);

      } else {
        // Handle Manual Adjusted Extra Cases
        newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);
      }
      return newSummary;
    };

    const handleExtraAdjstCases = (newSummary: any, extraAdjustmentCases: Map<any, any>) => {
      newSummary.map((item: any, row: any) => {
        let adjstCSVal = extraAdjustmentCases?.get(item.materialNum);
        adjstCSVal = adjstCSVal ? adjstCSVal : 0;
        item.adjstCS = adjstCSVal;
        let releaseTotalCS = item.totalCS + adjstCSVal + item.matAdjExtaCS;
        if (releaseTotalCS < 0) {
          releaseTotalCS = 0;
        }
        item.totalReleaseCS = releaseTotalCS;
        return item;
      });
      return newSummary;
    };

  const handleSelectionChange =  async (plant: string, route: string, filteredRoutes: []) => {
      //setState({...state, isLoading: true});
      // setRoutesSelected('');
      bufferedValue = [];
      const showLoading=route&&route!=''?true:false;
      resetRouteInfo(showLoading);
      setCurrentTab('planning');
      //console.log(plant, route);
      const planningDateStr = state.planningDate.toISOString().split('T')[0];
      resetReleaseState();
      if(route&&route!=''){
      // getRouteBuffer(salesOrg.toString(), plant, route).then((res) => {
      //   if(res?.data){
      //     const result = res?.data.reduce((result: any, currentValue: any) => {
      //       (result[currentValue?.material] = result[currentValue?.material] || []).push(currentValue);
      //         return result;
      //       }, {})
      //     bufferedValue = result
      //     setBufferValue(result)
      //   }
      // })
      getWarehouseLocation(salesOrg.toString(),plant).then((v) => {
          if(v && v.data) {
            if(v?.data[0]?.latitude && v?.data[0]?.longitude){
            state.warehouseLocation = v.data
            }
          }
        });
        
        let dates= await getHistoryFordatePicker(salesOrg.toString(),plant ,route);

        let  dateArray:any=[]
        if(dates){
          
          dates.forEach((element:any) => {
            dateArray.push( new Date(element.load_date).toISOString().split('T')[0]);
          });
          SetDatePickerData(dateArray)
        }

      getPlanningList(salesOrg.toString(), plant, route, planningDateStr).then(
        (v: any) => {
          //console.log("V+++++++++",v)
          let planningData: PlanningItem[] = v?.planning;
          const planningDataActual: PlanningItem[] = _.cloneDeep(v.planning);


          if(v?.routeBuffer){
            const result = v?.routeBuffer.reduce((result: any, currentValue: any) => {
              (result[currentValue?.material] = result[currentValue?.material] || []).push(currentValue);
                return result;
              }, {})
            bufferedValue = result
            setBufferValue(result)
          }
          
          const matDetails: MatDetail[] = v.matDetails;
          const planMode: string = v.planMode;
          const bufferStockFactor: number = v.bufferStockFactor;
          const routeInfoTrack: any =v?.routeInfoTrack || [];
          /**setting futureSusWrnDay as props to the planning.tsx */
          setFutureSusWrnDay(v?.futureSusWrnDay)
          const releaseDraft:ReleaseDraft[] = v.releaseDraft;
          const confirmedStatus:any=v.confirmedStatus?{confirmed:v.confirmedStatus?.stops,overdue:0,scheduled:0,banked:0,cases:v.confirmedStatus?.cs_bfr,act_cases:v.confirmedStatus?.cs,extras:v.confirmedStatus?.extras}:null;
          //check and update planningdata
          const updatedPlanningData=setReleaseDraft(releaseDraft,planningData).planningdata;
          if(updatedPlanningData&&updatedPlanningData.length>0){
            planningData=updatedPlanningData;
          }
          
          const hs = calcHeaderStats(planningData, state.planningDate, matDetails, bufferStockFactor,{plant: plant,route:route,planningDateStr:state.planningDate},planMode,confirmedStatus);
          const hsReview = calcHeaderStatsForReviwer(planningData, state.planningDate, matDetails, bufferStockFactor,{plant: plant,route:route,planningDateStr:state.planningDate},planMode,confirmedStatus);
          setPlanningDataState(planningData);
          setPlanningActDataState(planningDataActual);
          const updatedState ={...state, isLoading: false, selectedDeliveryPlant: plant, selectedRoute: route, 
            filteredRoutes: filteredRoutes, planningData: planningData,planningDataActual:planningDataActual, matDetails: matDetails, planMode: planMode, bufferStockFactor: bufferStockFactor,
            confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches:  hs.total_eaches, releaseDraft:releaseDraft,
            isReleaseDraftSaved: false,isRelaseDraftModified:false, routeInfoTrack: routeInfoTrack, enableReviewFeature: v?.enableReviewFeature, hsReview};

          //setState(updatedState);
          if(confirmedStatus){
            let newAutoSaveStateObj ={...autoSaveState};
            const updatedAutoSaveState = {...newAutoSaveStateObj,plant: plant,route:route,planningDateStr:planningDateStr,confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches:  hs.total_eaches, hsReview};
            setAutoSaveState(updatedAutoSaveState);
            setState(updatedState);
          }else{
            applyAdjustmentMaterials(updatedState,v.adjustedMaterials);
          }
        });
      
      }
  };

  function applyAdjustmentMaterials(updatedState:any,adjustedMaterials: any){
    const formatedDraft= setReleaseDraft(updatedState.releaseDraft);
    let newAutoSaveStateObj ={...autoSaveState};
    let newStateObj ={...state,releaseDraft:updatedState.releaseDraft};
      if(adjustedMaterials&&adjustedMaterials.length>0){
        const extraMats: any = adjustedMaterials;
        const updatedAutoSaveState = {adjestedMaterials:extraMats,adjstCases:formatedDraft?.adjstCases,isLoadResetActive:formatedDraft?.isZeroLoadActive,plant: updatedState.selectedDeliveryPlant, route:updatedState.selectedRoute,planningDateStr:updatedState.planningDate};
        const hs = calcHeaderStats(updatedState.planningData, updatedState.planningDate, updatedState.matDetails, updatedState.bufferStockFactor,updatedAutoSaveState,updatedState.planMode);
         const hsReview = calcHeaderStatsForReviwer(updatedState.planningData,  updatedState.planningDate, updatedState.matDetails, updatedState.bufferStockFactor,updatedAutoSaveState,updatedState.planMode);
        newAutoSaveStateObj={...updatedAutoSaveState ,plant: updatedState.selectedDeliveryPlant ,route:updatedState.selectedRoute,planningDateStr:updatedState.planningDate.toISOString().split('T')[0], confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
        setAutoSaveState(newAutoSaveStateObj);
        newStateObj={...updatedState, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
        setState(newStateObj);
      }else{
        const updatedAutoSaveState = {adjstCases:formatedDraft?.adjstCases,isLoadResetActive:formatedDraft?.isZeroLoadActive,plant: updatedState.selectedDeliveryPlant ,route:updatedState.selectedRoute,planningDateStr:updatedState.planningDate};
        const hs = calcHeaderStats(updatedState.planningData, updatedState.planningDate, updatedState.matDetails, updatedState.bufferStockFactor,updatedAutoSaveState,updatedState.planMode);
        const hsReview = calcHeaderStatsForReviwer(updatedState.planningData,  updatedState.planningDate, updatedState.matDetails, updatedState.bufferStockFactor,updatedAutoSaveState,updatedState.planMode);
        newAutoSaveStateObj={...updatedAutoSaveState, planningDateStr:updatedState.planningDate.toISOString().split('T')[0],plant: updatedState.selectedDeliveryPlant , confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
        newStateObj={...updatedState,adjestedMaterials:[], confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
        setState(newStateObj);
        setAutoSaveState(newAutoSaveStateObj);
      }
      saveDraft(newStateObj,newAutoSaveStateObj);
  }


  const getAdjustmentMaterials =(updatedState:any, plant: string, route: string)=>{
    const planningDateStr = updatedState.planningDate.toISOString().split('T')[0];
    if(salesOrg&&plant&&route&&planningDateStr){
      getMaterialAdjustments(salesOrg.toString(), plant,route, planningDateStr).then((v: any) => {
          let adjustedMaterials=[];
            if(v&&v.matDetails&&v.matDetails.length>0){
              adjustedMaterials=v.matDetails;
            }
            applyAdjustmentMaterials(updatedState,adjustedMaterials);
          });
    }
  }

  const resetRouteInfo = (isLoading:boolean) =>{
    setPlanningDataState([]);
    setState({...state,
    isLoading,
    selectedDeliveryPlant: "",
    selectedRoute: "",
    filteredRoutes: [],
    planningData: [],matDetails: [],
    planningDataActual:[], releaseDraft:[],
    overdue: 0, scheduled: 0, banked: 0, cases: 0,act_cases:0, extras: 0,
    hsReview:{
        reviewConfirmed: 0,
        reviewOverdue: 0,
        reviewScheduled: 0,
        reviewBanked: 0,
        reviewCases: 0,
        reviewActCases: 0,
        reviewExtras: 0,
        reviewEaches: 0
      }});
  }

  const refreshExtraMats = () =>{
    if(autoSaveState&&autoSaveState.adjstCases&&autoSaveState.adjstCases.size>0){
      const addedMaterials = new Set(); 
      if(autoSaveState.adjestedMaterials&&autoSaveState.adjestedMaterials.length>0){
        autoSaveState.adjestedMaterials.map((item:any) => {
          addedMaterials.add(item.material_num);
        });
      }
      if(state&&state.planningData&&state.planningData.length>0){
        const items: PlanningItem[]= state.planningData.filter(elem => elem.status === "S" && elem.nextDeliveryAct === autoSaveState.planningDateStr);
        for (var i=0; i<items.length; i++) {
          const item = items[i];
          for (var j=0; j<item.details.length; j++) {
            if (item.activity === "NORM" || item.activity === "INIT" || item.equipmentStatus === "NOPH") {
              const mat = item.details[j];
              addedMaterials.add(mat.material_num);
            }
          }
        }
      }
      const extraCases=_.cloneDeep(autoSaveState.adjstCases);
      let totalExtraCases =0 ;
      autoSaveState.adjstCases.forEach((value: number, key: string) => {
          if(addedMaterials.has(key)){
            totalExtraCases += value;
          }else{
            extraCases.delete(key);
          }
        });
      return {...autoSaveState,adjstCases:extraCases,route:state.selectedRoute,planningDateStr:state.planningDate.toISOString().split('T')[0]};
    }
    return {...autoSaveState, route:state.selectedRoute,planningDateStr:state.planningDate.toISOString().split('T')[0]};
  }

  const handleItemChange = (item: PlanningItem, index: number) => {
    var planningData = _.cloneDeep(planningDataState);//state.planningData;
    const planningDataActual:PlanningItem[] =_.cloneDeep(planningActDataState);// _.cloneDeep(state.planningDataActual);
    item.sort = getRowSort(item, state.planningDate);
    planningData[index] = item;
    planningDataActual[index]=item;

    const updatedAutoSaveState = refreshExtraMats();
    const hs = calcHeaderStats(planningData, state.planningDate, state.matDetails, state.bufferStockFactor,updatedAutoSaveState);
    const hsReview = calcHeaderStatsForReviwer(planningData, state.planningDate, state.matDetails, state.bufferStockFactor,updatedAutoSaveState);
    setPlanningDataState(planningData);
    setPlanningActDataState(planningDataActual);
    const newStateInstance ={...state, planningData: planningData,planningDataActual:planningDataActual, confirmed:hs.confirmed,  overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
    //setState(newStateInstance);
    const newAutoSaveStateInstance={...updatedAutoSaveState, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
    setAutoSaveState(newAutoSaveStateInstance);
    saveDraft(newStateInstance,newAutoSaveStateInstance);
  }







  const handleItemsChange = (items: PlanningItem[]) => {
    const planningDataActual:PlanningItem[] =_.cloneDeep(planningActDataState);

    var updItems = new Array<PlanningItem>();
    const customerNums:any[]=[];
    for (var i=0; i<items.length; i++) {
      var item = items[i];
      item.sort = getRowSort(item, state.planningDate);
      updItems.push(item);
      customerNums.push(item?.customerNum);
    }
  
    var newActItems = planningDataActual?.filter((item: any) => (customerNums?.includes(item?.customerNum)));

    const updatedAutoSaveState = refreshExtraMats();
    const hs = calcHeaderStats(updItems, state.planningDate, state.matDetails, state.bufferStockFactor,updatedAutoSaveState);
    setPlanningDataState(updItems);
    setPlanningActDataState(newActItems);
    const newStateInstance = {...state, planningData: updItems,planningDataActual:newActItems, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches:  hs.total_eaches};
    setState(newStateInstance);
    const newAutoSaveStateInstance={...updatedAutoSaveState, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked,cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches:  hs.total_eaches};
    setAutoSaveState(newAutoSaveStateInstance);
    saveDraft(newStateInstance,newAutoSaveStateInstance);
  }

  const reloadHeaderStats = () =>{
    const updatedAutoSaveState = refreshExtraMats();
    const hs = calcHeaderStats(state.planningData, state.planningDate, state.matDetails, state.bufferStockFactor, updatedAutoSaveState);
    handleCSUpdate(hs);
    setAutoSaveState({...updatedAutoSaveState, confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked,cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches});
  }

  const resetReleaseState = () => {
    //setState({...state, planningData: [],planningDataActual:[],matDetails: [],releaseDraft:[], overdue: 0, scheduled: 0, banked: 0, cases: 0, act_cases: 0, extras: 0});
    setAutoSaveState({});
    setPlanningDataState([]);
    setPlanningActDataState([]);
    setAlert({
      is_disable:false,
      message:''
    })
  }


  const getBuffer = (matDetails: any, type: string,plant:any,route:any) => {
    const bufferValues =  Object.keys(bufferValue).length > 0 ? bufferValue :bufferedValue ?? []

    // const selectedRoute =state.selectedRoute;
    // const selectedDeliveryPlant=state.selectedDeliveryPlant;

    const selectedRoute =route || state.selectedRoute || sessionStorage.getItem("selectedRoute");
    const selectedDeliveryPlant=plant || state.selectedRoute || sessionStorage.getItem("selectedDeliveryPlant");

    const BUFFER_LEVEL_MATERIAL=3;
    const BUFFER_LEVEL_ROUTE=2;
    const BUFFER_LEVEL_PLANT=1;
    const BUFFER_LEVEL_ALL=0;

    const selMaterialBufferList=bufferValues[matDetails?.material_num_short];
    if(selMaterialBufferList&&selMaterialBufferList?.length > 0){
      let buffer=0;
      let bufferApplied =false;
      for (let index = 0; index < selMaterialBufferList.length; index++) {
        const bufferItem = selMaterialBufferList[index];
        let bufferLevelPriority=0;
        if(bufferItem?.deliveryPlant === selectedDeliveryPlant){
          if(bufferItem?.route === selectedRoute){
              if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_ROUTE;
                bufferApplied=true;
              }
            }else if (bufferItem?.route =="All") {
              if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_PLANT;
                bufferApplied=true;
              }
            }
        }
      }
      if(bufferApplied){
        return buffer;
      }
    }
    if(bufferValues?.All){
      const allVal = bufferValues?.All
      let buffer=0;
      let bufferLevelPriority=0;

      for (let index = 0; index < allVal.length; index++) {
        const item = allVal[index];
        if(item?.deliveryPlant === selectedDeliveryPlant){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }
        }else if(item?.deliveryPlant === 'All'){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }else{
            if(bufferLevelPriority<=BUFFER_LEVEL_ALL){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ALL;
            }
          }
        }
      }
      return buffer
    }
    return 0
  }

  const calculateAdjustedLoad = (matDetails: any,plant?:any, route?:any) => {
    let res = 0
    const onlineBuffer = getBuffer(matDetails, 'online',plant,route)
    const offlineBuffer = getBuffer(matDetails, 'offline',plant,route)
    if(matDetails?.ftcRefilQty){
      res += matDetails?.ftcRefilQty 
    }
    if(matDetails?.onlineRefilQty){
      res += (matDetails?.onlineRefilQty) + (matDetails?.onlineRefilQty * (onlineBuffer / 100))
    }
    if(matDetails?.offlineRefilQty){
      res += (matDetails?.offlineRefilQty) + (matDetails?.offlineRefilQty * (offlineBuffer / 100))
    }
  //console.log('🚀 ~ file: Release.tsx ~ line 320 ~ calculateAdjustedLoad ~ matDetails', matDetails)
  return Math.ceil(res)
  };


  const calcHeaderStats = (items: PlanningItem[], date: Date, matDetails: MatDetail[], bufferStockFactor: number, exAutoSaveState?:any,planMode?:any,confirmedStatus?:HeaderStats): HeaderStats => {
    let hs:HeaderStats = {
      confirmed:0,
      overdue: 0,
      scheduled: 0,
      banked: 0,
      cases: 0,
      act_cases: 0,
      extras:0,
      total_eaches: 0,
    };

    if(confirmedStatus){
      return confirmedStatus;
    }

    //
    let totalEaches: number = 0;

    const PM_DYN = "DYNAMIC";
    const planningMode = planMode&&planMode.length>0?planMode:state.planMode
    const existingAutoSaveState= exAutoSaveState?exAutoSaveState:autoSaveState;
    var bankedMap = new Map<string, boolean>();
    var matMap = new Map<string, number>();
    const bufferMeta: any = {};
    if (items && date) {

      items.map((item) => {
         const plDate = date.toISOString()?.split("T")[0];
         //console.log('plDate', plDate);
          const nextDelAct = item?.nextDeliveryAct ? 
          new Date(Date.parse(item?.nextDeliveryAct))?.toISOString()?.split("T")[0] : '';
          let scheduledDates = [];
           for (let j=0; j<item.sheduled.length; j++){
             scheduledDates.push(item.sheduled[j].visit_dt_plan);
           }
           const closestDate = getPreviousSheduledList(scheduledDates,plDate);
           const currentPlDate:any = new Date(plDate);
           let clstDate:any = new Date(closestDate);
           let clstDateDiff = Math.ceil(Math.abs(clstDate - currentPlDate)/(1000 * 60 * 60 * 24));
           const lastDelDate:any = new Date(item.lastDelivery);
           let lastDeliverydiff = Math.ceil(Math.abs(lastDelDate - currentPlDate)/(1000 * 60 * 60 * 24));
           
           //item.currentStatus = "O"

           if (nextDelAct > plDate && item.dri >= 0) {
            item.currentStatus = "F"
           }
           
           if(lastDeliverydiff > 60  && clstDateDiff > 60){
            item.currentStatus = "O";

           }


           if(item?.sheduled?.length == 0 && new Date(item?.nextDeliveryAct) > new Date(plDate) && item?.dri < 0) {
            item.currentStatus = 'O';
           }



           if(item.sheduled.length > 0 && new Date(item.nextDeliveryAct) > new Date(plDate)) {
            item.currentStatus = 'S';
           }


           if (item.nextDeliveryAct <= plDate) {
            if(item.status === 'P'){
             // item.currentStatus = 'O';
            }

            if(item.status === 'S'){
              item.currentStatus = 'S';
            }
           }

           

           if (item.status == 'S') {
            item.currentStatus = 'S';
           }

           if(item.status == 'C') {
            item.currentStatus = 'C';
           }

            let odstatus = [];
            let cStatus = [];
           // let futurestatus = [];
           for(let m=0; m<items.length;m++){
            if(items[m].currentStatus === 'O'){
                odstatus.push(items[m].customerNum);
            }

            if(items[m].currentStatus === 'C'){
              cStatus.push(items[m].customerNum);
            }

            // if(items[m].currentStatus === 'F'){
            //   futurestatus.push(items[m].customerNum);
            //  }
            
           }

           //console.log("ITEM:", items );

           hs.overdue = odstatus?.length;
           hs.confirmed = cStatus?.length;


        //if (item.status === "S" && item.nextDeliveryAct === date.toISOString().split("T")[0]) {
        if ((item.status === "S"||item.status === "C") && new Date(Date.parse(item.nextDeliveryAct)).toISOString().split("T")[0] === date.toISOString().split("T")[0]  )  {
           hs.scheduled++;
          if(item.activity !="DISP" &&  item.activity !="PREM"){
          if (item.bank) {
            bankedMap.set(item.bank, true);
          } else {
            bankedMap.set(item.customerNum, true);
          }
          if (item.details) {
            item.details.map((detail) => {
              var units = matMap.get(detail.material_num) || 0;
              //if (state.planMode != PM_DYN) {
              if(units){
                if(item?.ftc){
                  let ftcRefillQty = bufferMeta[detail.material_num]?.ftcRefilQty ?? 0
                  ftcRefillQty += detail.refill_qty
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    ftcRefilQty : ftcRefillQty
                  }
                }else if(item?.online){
                  let online = bufferMeta[detail.material_num]?.onlineRefilQty ?? 0
                  online += detail.refill_qty
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    onlineRefilQty : online
                  }
                }else{
                  let offline = bufferMeta[detail.material_num]?.offlineRefilQty ?? 0
                  offline += detail.refill_qty
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    offlineRefilQty : offline
                  }
                }
              }else{
                bufferMeta[detail.material_num] = {
                  material_num: detail.material_num,
                  material_num_short: parseInt(detail.material_num).toString(),
                };
                if(item?.ftc){
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    ftcRefilQty : detail.refill_qty
                  }
                }else if(item?.online){
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    onlineRefilQty : detail.refill_qty
                  }
                }else{
                  bufferMeta[detail.material_num] = {
                    ...bufferMeta[detail.material_num],
                    offlineRefilQty : detail.refill_qty
                  }
                }
              }
            //}
              units += detail.refill_qty;
              matMap.set(detail.material_num, units);
            })
          }
        }
        }
      });
      //console.log(matMap);
      const materialKeys = Array.from(matMap.keys());
      materialKeys?.map((matKey) => {
        const units = matMap.get(matKey) || 0;
        const adjUnits = calculateAdjustedLoad(bufferMeta[matKey],existingAutoSaveState?.plant,existingAutoSaveState?.route);
        const matDetail = matDetails.find(elem => elem.materialNum === matKey);

        if (matDetail && matDetail.denominator && matDetail.numerator) {
          let count = Math.ceil(adjUnits / (matDetail.denominator * matDetail.numerator));
          let actCount = Math.ceil(units / (matDetail.denominator * matDetail.numerator));

          totalEaches = totalEaches + units;
          if (count === 0) {
            count = 1;
          }
          if (actCount === 0) {
            actCount = 1;
          }

          if(existingAutoSaveState){
            let adjustedVal =0;
            if(existingAutoSaveState.adjestedMaterials){
             const adjustedItem = existingAutoSaveState.adjestedMaterials.find((mat:any) => matKey === mat.material_num);
             adjustedVal = adjustedItem&&adjustedItem.quantity?adjustedItem.quantity:0;
             if(adjustedItem&&adjustedItem.clear_load){
              count = 0;
              //actCount = 0;
              adjustedVal = 0;
             }
            }
            let extraCSVal = existingAutoSaveState.adjstCases? existingAutoSaveState.adjstCases.get(matKey):0;
            extraCSVal =extraCSVal?extraCSVal:0;
            if(existingAutoSaveState.isLoadResetActive!==undefined&&existingAutoSaveState.isLoadResetActive){
              count = 0; //resetting to zero if load reset active    
              actCount = 0;
            }
            count = count+adjustedVal+extraCSVal;
            actCount = actCount;
            if(count<=0){
              count = 0;
              hs.extras += adjustedVal>0?adjustedVal:0;
            }else{
              let adjstSum = adjustedVal+extraCSVal;
              adjstSum = adjstSum>0?adjstSum:0;
              hs.extras += adjstSum;
            }
            if(actCount<=0){
              actCount = 0;
            }
          }
          hs.cases+=count;
          hs.act_cases+=actCount;
        }
      });
      //having total eaches
      hs.total_eaches = totalEaches;
         
      if(existingAutoSaveState&&existingAutoSaveState.adjestedMaterials){
        let remExtraCS = 0;
        let remCases = 0;
        existingAutoSaveState.adjestedMaterials.map((mat:any) => {
          if(!materialKeys.includes(mat.material_num)){
            const adjstCS = mat.clear_load?0:mat.quantity;
            let extraCSVal = existingAutoSaveState.adjstCases? existingAutoSaveState.adjstCases.get(mat.material_num):0;
            extraCSVal =extraCSVal?extraCSVal:0;
            let totalExtras = extraCSVal+ adjstCS;
            let casesExtra = totalExtras>0?totalExtras:0;
            if(existingAutoSaveState.isLoadResetActive!==undefined&&existingAutoSaveState.isLoadResetActive){
              casesExtra = adjstCS; //resetting to adjustment value alone if load reset active
            }
            if(totalExtras<0){
              totalExtras=0;
            }
            remExtraCS += totalExtras;
            remCases += casesExtra;
          }
        });
        hs.extras+=remExtraCS;
        hs.cases+=remCases;
        //hs.act_cases+=remCases;
      }
      const bankedKeys = Array.from(bankedMap.keys());
      hs.banked = bankedKeys.length;
    }
    
    return hs;
  }

  const calcHeaderStatsForReviwer = (items: PlanningItem[], date: Date, matDetails: MatDetail[], bufferStockFactor: number, exAutoSaveState?:any,planMode?:any,confirmedStatus?:ReviewHeaderStats): ReviewHeaderStats => {

    let reviewHS: ReviewHeaderStats = {
      reviewConfirmed:0,
      reviewOverdue: 0,
      reviewScheduled: 0,
      reviewBanked: 0,
      reviewCases: 0,
      reviewActCases: 0,
      reviewExtras:0,
      reviewEaches:0
    };

    let totalEaches: number = 0;

    if(!isDisplayOnlyRole){
      return reviewHS;
    }

    if(confirmedStatus){
      return confirmedStatus;
    }

    const existingAutoSaveState= _.cloneDeep(exAutoSaveState?exAutoSaveState:autoSaveState);
    var bankedMap = new Map<string, boolean>();
    var matMap = new Map<string, number>();
    const bufferMeta: any = {};

    const newItems: PlanningItem[] = _.cloneDeep(items);
    if (newItems && date) {

      newItems.map((item) => {
         const plDate = date.toISOString()?.split("T")[0];
         //console.log('plDate', plDate);
          const nextDelAct = item?.nextDeliveryAct ? 
          new Date(Date.parse(item?.nextDeliveryAct))?.toISOString()?.split("T")[0] : '';
          let scheduledDates = [];
           for (let j=0; j<item.sheduled.length; j++){
             scheduledDates.push(item.sheduled[j].visit_dt_plan);
           }
           const closestDate = getPreviousSheduledList(scheduledDates,plDate);
           const currentPlDate:any = new Date(plDate);
           let clstDate:any = new Date(closestDate);
           let clstDateDiff = Math.ceil(Math.abs(clstDate - currentPlDate)/(1000 * 60 * 60 * 24));
           const lastDelDate:any = new Date(item.lastDelivery);
           let lastDeliverydiff = Math.ceil(Math.abs(lastDelDate - currentPlDate)/(1000 * 60 * 60 * 24));
          
          //#Area Of Logic Start-101
          // Area where we are checking the provided review comments and doing the calculation based on that
          //changing the status so that calculation will be performaed for review header
          if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && item.status == 'P' && item?.txVisitPlanningReview[0]?.schedulePlan == "S"){
              item.status = "S";
              item.currentStatus = "S";
          }else if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && item.status == 'S' && item?.txVisitPlanningReview[0]?.schedulePlan == "P"){
              item.status = "P";
              item.currentStatus = "O";
          }

          //Cheching for FTC
          if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && (item?.ftc == false && item?.txVisitPlanningReview[0]?.ftcPlan == true)){
            item.ftc = true;
            item.details.map((ele: any)=> {
              ele.refill_qty = ele?.consignment;
              return ele;
            });
          }else if (item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && (item?.ftc == true && item?.txVisitPlanningReview[0]?.ftcPlan == false)){
            item.ftc = false;
          }

          //Cheching for Activity
          if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && (item?.activity == "NORM" && item?.txVisitPlanningReview[0]?.activityPlan != "NORM")){
            item.activity = item?.txVisitPlanningReview[0]?.activityPlan;
          }else if (item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && (item?.activity != "NORM")){
            item.activity = item?.txVisitPlanningReview[0]?.activityPlan;
          }

          // //route change case
          if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && item?.txVisitPlanningReview[0]?.routePlan != existingAutoSaveState?.route){
              item.status = "P";
              item.currentStatus = "O";
          }else if(item?.txVisitPlanningReview && item?.txVisitPlanningReview?.length && (item?.txVisitPlanningReview[0]?.routePlan == existingAutoSaveState?.route) &&
              (item?.routeAct != existingAutoSaveState?.route)){
              item.status = "S";
              item.currentStatus = "S";
          }

          //#Area Of Logic Finish-101

           if (nextDelAct > plDate && item.dri >= 0) {
            item.currentStatus = "F"
           }
           
           if(lastDeliverydiff > 60  && clstDateDiff > 60){
            item.currentStatus = "O";

           }


           if(item?.sheduled?.length == 0 && new Date(item?.nextDeliveryAct) > new Date(plDate) && item?.dri < 0) {
            item.currentStatus = 'O';
           }



           if(item.sheduled.length > 0 && new Date(item.nextDeliveryAct) > new Date(plDate)) {
            item.currentStatus = 'S';
           }


           if (item.nextDeliveryAct <= plDate) {
            if(item.status === 'P'){
             // item.currentStatus = 'O';
            }

            if(item.status === 'S'){
              item.currentStatus = 'S';
            }
           }

           

           if (item.status == 'S') {
            item.currentStatus = 'S';
           }

           if(item.status == 'C') {
            item.currentStatus = 'C';
           }

            let odstatus = [];
            let cStatus = [];
           // let futurestatus = [];
           for(let m=0; m<newItems.length;m++){
            const oldStatusInner: string = newItems[m].status;
            const oldCurrentStatusInner: string = newItems[m].currentStatus;
            if(newItems[m]?.txVisitPlanningReview && items[m]?.txVisitPlanningReview?.length && newItems[m].status == 'P' && newItems[m]?.txVisitPlanningReview[0]?.schedulePlan == "S"){
              newItems[m].status = "S";
              newItems[m].currentStatus = "S";
            }else if(newItems[m]?.txVisitPlanningReview && newItems[m]?.txVisitPlanningReview?.length && newItems[m].status == 'S' && newItems[m]?.txVisitPlanningReview[0]?.schedulePlan == "P"){
              newItems[m].status = "P";
              newItems[m].currentStatus = "O";
            }
            if(newItems[m].currentStatus === 'O'){
                odstatus.push(newItems[m].customerNum);
            }

            if(newItems[m].currentStatus === 'C'){
              cStatus.push(newItems[m].customerNum);
            }

            //revert status
            newItems[m].status = oldStatusInner;
            newItems[m].currentStatus = oldCurrentStatusInner;
            
           }

           //console.log("ITEM:", items );

           reviewHS.reviewOverdue = odstatus?.length;
           reviewHS.reviewConfirmed = cStatus?.length;


          //if (item.status === "S" && item.nextDeliveryAct === date.toISOString().split("T")[0]) {
          if ((item.status === "S"||item.status === "C"))  {
            reviewHS.reviewScheduled++;
            if(item.activity !="DISP" &&  item.activity !="PREM"){
            if (item.bank) {
              bankedMap.set(item.bank, true);
            } else {
              bankedMap.set(item.customerNum, true);
            }
            if (item.details) {
              item.details.map((detail) => {
                var units = matMap.get(detail.material_num) || 0;
                //if (state.planMode != PM_DYN) {
                if(units){
                  if(item?.ftc){
                    let ftcRefillQty = bufferMeta[detail.material_num]?.ftcRefilQty ?? 0
                    ftcRefillQty += detail.refill_qty
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      ftcRefilQty : ftcRefillQty
                    }
                  }else if(item?.online){
                    let online = bufferMeta[detail.material_num]?.onlineRefilQty ?? 0
                    online += detail.refill_qty
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      onlineRefilQty : online
                    }
                  }else{
                    let offline = bufferMeta[detail.material_num]?.offlineRefilQty ?? 0
                    offline += detail.refill_qty
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      offlineRefilQty : offline
                    }
                  }
                }else{
                  bufferMeta[detail.material_num] = {
                    material_num: detail.material_num,
                    material_num_short: parseInt(detail.material_num).toString(),
                  };
                  if(item?.ftc){
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      ftcRefilQty : detail.refill_qty
                    }
                  }else if(item?.online){
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      onlineRefilQty : detail.refill_qty
                    }
                  }else{
                    bufferMeta[detail.material_num] = {
                      ...bufferMeta[detail.material_num],
                      offlineRefilQty : detail.refill_qty
                    }
                  }
                }
              //}
                units += detail.refill_qty;
                matMap.set(detail.material_num, units);
              })
            }
          }
          }

      });
      //console.log(matMap);
      const materialKeys = Array.from(matMap.keys());
      materialKeys?.map((matKey) => {
        const units = matMap.get(matKey) || 0;
        const adjUnits = calculateAdjustedLoad(bufferMeta[matKey],existingAutoSaveState?.plant,existingAutoSaveState?.route);
        const matDetail = matDetails.find(elem => elem.materialNum === matKey);
        if (matDetail && matDetail.denominator && matDetail.numerator) {
          let count = Math.ceil(adjUnits / (matDetail.denominator * matDetail.numerator));
          let actCount = Math.ceil(units / (matDetail.denominator * matDetail.numerator));
          totalEaches = totalEaches + units;
          if (count === 0) {
            count = 1;
          }
          if (actCount === 0) {
            actCount = 1;
          }

          if(existingAutoSaveState){
            let adjustedVal =0;
            if(existingAutoSaveState.adjestedMaterials){
             const adjustedItem = existingAutoSaveState.adjestedMaterials.find((mat:any) => matKey === mat.material_num);
             adjustedVal = adjustedItem&&adjustedItem.quantity?adjustedItem.quantity:0;
             if(adjustedItem&&adjustedItem.clear_load){
              count = 0;
              //actCount = 0;
              adjustedVal = 0;
             }
            }
            let extraCSVal = existingAutoSaveState.adjstCases? existingAutoSaveState.adjstCases.get(matKey):0;
            extraCSVal =extraCSVal?extraCSVal:0;
            if(existingAutoSaveState.isLoadResetActive!==undefined&&existingAutoSaveState.isLoadResetActive){
              count = 0; //resetting to zero if load reset active    
              actCount = 0;
            }
            count = count+adjustedVal+extraCSVal;
            actCount = actCount;
            if(count<=0){
              count = 0;
              reviewHS.reviewExtras += adjustedVal>0?adjustedVal:0;
            }else{
              let adjstSum = adjustedVal+extraCSVal;
              adjstSum = adjstSum>0?adjstSum:0;
              reviewHS.reviewExtras += adjstSum;
            }
            if(actCount<=0){
              actCount = 0;
            }
          }
          reviewHS.reviewCases+=count;
          reviewHS.reviewActCases+=actCount;
        }
      });
      reviewHS.reviewEaches = totalEaches;
          // if (planningMode == PM_DYN) {
          //   hs.cases = hs.act_cases;
          // }
      if(existingAutoSaveState&&existingAutoSaveState.adjestedMaterials){
        let remExtraCS = 0;
        let remCases = 0;
        existingAutoSaveState.adjestedMaterials.map((mat:any) => {
          if(!materialKeys.includes(mat.material_num)){
            const adjstCS = mat.clear_load?0:mat.quantity;
            let extraCSVal = existingAutoSaveState.adjstCases? existingAutoSaveState.adjstCases.get(mat.material_num):0;
            extraCSVal =extraCSVal?extraCSVal:0;
            let totalExtras = extraCSVal+ adjstCS;
            let casesExtra = totalExtras>0?totalExtras:0;
            if(existingAutoSaveState.isLoadResetActive!==undefined&&existingAutoSaveState.isLoadResetActive){
              casesExtra = adjstCS; //resetting to adjustment value alone if load reset active
            }
            if(totalExtras<0){
              totalExtras=0;
            }
            remExtraCS += totalExtras;
            remCases += casesExtra;
          }
        });
        reviewHS.reviewExtras+=remExtraCS;
        reviewHS.reviewCases+=remCases;
        //hs.act_cases+=remCases;
      }
      const bankedKeys = Array.from(bankedMap.keys());
      reviewHS.reviewBanked = bankedKeys.length;
    }

   return reviewHS;
  }

  const handleCSUpdate = (hs:HeaderStats) => {
    setState({...state, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras});
  }

  const handleBackendConfirm = () => {
    // const selectedSalesOffice = state.selectedSalesOffice;
    const selectedDeliveryPlant = state.selectedDeliveryPlant;
    const selectedRoute = state.selectedRoute;
    const filteredRoutes = state.filteredRoutes;
    handleSelectionChange(selectedDeliveryPlant, selectedRoute, filteredRoutes);
  }

  const setIsLoading = (isLoading: boolean) => {
    setState({...state, isLoading});
  }

  const handleDateChange = (newDate: Date) => {
    setState({...state, planningDate: newDate});
    const selectedRoute =state.selectedRoute.slice()|| sessionStorage.getItem("selectedRoute");
    const selectedDeliveryPlant= state.selectedDeliveryPlant.slice() || sessionStorage.getItem("selectedDeliveryPlant");


    if(selectedDeliveryPlant && selectedRoute){
      setState({...state, isLoading: true});
      setCurrentTab('planning');
      const planningDateStr = newDate.toISOString().split('T')[0];
      resetReleaseState();

      // const salesOffice = state.selectedSalesOffice.slice();
      const plant =selectedDeliveryPlant  
      const route = selectedRoute 
      getPlanningListData(salesOrg.toString(),plant,route,planningDateStr)

    
    }
  }

  function getRowSort(planningItem: PlanningItem, planningDate: Date): string {
    var sort = "";
    var accessD = "";
    if (planningItem.prefDays != "") {
      accessD = planningItem.prefDays;
    } else {
      accessD = planningItem.accessDays;
    }
    const weekday: number = planningDate.getUTCDay();
    var abbrev: string = "";
    switch (weekday) {
      case 0:
        abbrev = "Su";
        break;
      case 1:
        abbrev = "M";
        break;
      case 2:
        abbrev = "Tu";
        break;
      case 3:
        abbrev = "W";
        break;
      case 4:
        abbrev = "Th";
        break;
      case 5:
        abbrev = "F";
        break;
      case 6:
        abbrev = "Sa";
        break;
    }
    // act planning date is first criterium
    if (planningItem?.nextDeliveryAct?.toString() === planningDate?.toISOString().split('T')[0]) {
      sort = sort + "0";
    } else {
      sort = sort + "1";
    }
    // status is next
    if (planningItem.status === 'S') {
      sort = sort + "0";
    } else if (planningItem.status === 'P') {
      sort = sort + "1";
    } else {
      sort = sort + "2";
    }
    // followed by access day
    if (accessD.includes(abbrev)) {
      sort = sort + "0";
    } else {
      sort = sort + "1";
    }
    // lastly, use actual planning date
    sort = sort + planningItem?.nextDeliveryAct?.toString();
  
    return sort;
  }



  useEffect(() => {
    if (state.isLoaded){ return;}
    if (salesOrg&&salesOrg.length>0){

    getSalesOfficesAndRoutes(salesOrg.toString()).then((v:any) => {
      //console.log("gavchgsv",v)
        const r_so:any[] = v.plants;
        const r_rt:any[] = v.routes;
        if (r_so && r_rt) {
          requestMissingContexts(["PLANTS"]).then((ctx) => {
            const contexts:any = ctx;
            var plants: Array<DeliveryPlant> = [];
            for (var i=0; i<r_so.length; i++) {
        
              const so = r_so[i].plant;
              const desc = so + ": " + determineConfig(
                contexts,
                "PLANTS",
                so || ""
              );
              const deliveryPlant:DeliveryPlant = {plant: so, name: desc};
              plants.push(deliveryPlant);
            }
            setState({
              ...state,
              isLoaded: true,
               plants,
              routes: r_rt
            });
          });
        }
      });
    }
  }, [state]);

  useEffect(() => {
    if(refresh){
      setCurrentTab('planning');
      setState({...state, isLoading: true});
      const planningDateStr = state.planningDate.toISOString().split('T')[0];
      const plant = state.selectedDeliveryPlant.slice();
      const route = state.selectedRoute.slice(); 
      getPlanningListData(salesOrg.toString(),plant,route,planningDateStr)
    
    }
  },[refresh])

  let getPlanningListData=(salesOrg:any,plant:any,route:any,planningDateStr:any)=>{
    getPlanningList(salesOrg, plant, route, planningDateStr).then(
      (v: any) => {
                  setRefresh(false);
                  setAlert({
                    is_disable:false,
                    message:''
                  })
                  let planningData: PlanningItem[] = v.planning;
                  const planningDataActual: PlanningItem[] =  _.cloneDeep(v.planning);
                  const matDetails: MatDetail[] = v.matDetails;
                  const planMode: string = v.planMode;
                  const bufferStockFactor: number = v.bufferStockFactor;
                  const routeInfoTrack: any =v?.routeInfoTrack || [];
                  /**setting futureSusWrnDay as props to the planning.tsx */
                  setFutureSusWrnDay(v?.futureSusWrnDay);
                  const releaseDraft:ReleaseDraft[] = v.releaseDraft;
                  //check and update planningdata
                  const updatedPlanningData=setReleaseDraft(releaseDraft,planningData).planningdata;
                  if(updatedPlanningData&&updatedPlanningData.length>0){
                    planningData=updatedPlanningData;
                  }
                  const confirmedStatus:any=v.confirmedStatus?{confirmed:v.confirmedStatus?.stops,overdue:0,scheduled:0,banked:0,cases:v.confirmedStatus?.cs_bfr,act_cases:v.confirmedStatus?.cs,extras:v.confirmedStatus?.extras}:null;
                  const hs = calcHeaderStats(planningData, new Date(planningDateStr), matDetails, bufferStockFactor,{route,planningDateStr},planMode,confirmedStatus);
                  const hsReview = calcHeaderStatsForReviwer(planningData, new Date(planningDateStr), matDetails, bufferStockFactor,{route,planningDateStr},planMode,confirmedStatus);
                  setPlanningDataState(planningData);
                  setPlanningActDataState(planningDataActual);
                  const updatedState = {...state, isLoading: false, planningData: planningData,planningDataActual:planningDataActual, planningDate: new Date(planningDateStr), matDetails: matDetails, planMode: planMode, bufferStockFactor: bufferStockFactor,
                    confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, isReleaseDraftSaved: false,isRelaseDraftModified:false,releaseDraft:releaseDraft, routeInfoTrack: routeInfoTrack, enableReviewFeature: v?.enableReviewFeature,
                      hsReview
                    };
                    if(confirmedStatus){
                    let newAutoSaveStateObj ={...autoSaveState};
                    const updatedAutoSaveState = {...newAutoSaveStateObj,route:route,planningDateStr:planningDateStr,confirmed:hs.confirmed, overdue: hs.overdue, scheduled: hs.scheduled, banked: hs.banked, cases: hs.cases, act_cases: hs.act_cases, extras: hs.extras, total_eaches: hs.total_eaches, hsReview};
                    setAutoSaveState(updatedAutoSaveState);
                    setState(updatedState);
                  }else{
                    getAdjustmentMaterials(updatedState,plant, route);
                  }
    });
  
  }


  return (
   
    <ResponsiveDrawer
      title="Vend Smart Route Planning"
    >
      <Container maxWidth={false} className={classes.container}>
      <Header
          setRoutesSelected={setRoutesSelected}
          routeEvent={routeEvent}
          salesOrgEvent={salesOrgEvent}
          setRouteEvent={setRouteEvent}
          setSalesOrgEvent={setSalesOrgEvent}
          setAlertClearRoute={setAlertClearRoute}
          routesSelected={routesSelected}
          data={state}
          onSelectionChange={handleSelectionChange}
          onDateChange={handleDateChange}
          tomorrow={tomorrow}
          datePickerData={datePickerData}
      />

      <Box mt={1}>
          <Tabs
            onChange={handleTabsChange}
            variant="fullWidth"
            value={currentTab}
            textColor="primary"
            indicatorColor="primary"
          >
            {tabs.map((tab) => (
          (tab.value == 'release' && state.confirmed>0)
           ? (<Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
           disabled
          />)
           : <Tab
           key={tab.value}
           label={tab.label}
           value={tab.value}
          disabled={state.isLoading}
         />
              
            ))}
          </Tabs>
        </Box>
       
        <Divider />
          {currentTab === 'planning' && <Planning setSalesOrgEvent={setSalesOrgEvent} setRouteEvent={setRouteEvent} setAlertClearRoute={setAlertClearRoute} alertClearRoute={alertClearRoute} routesSelected={setRoutesSelected} futureSusWrnDay={futureSusWrnDay} salesOrg={salesOrg.toString()} plant={state.selectedDeliveryPlant} isLoading={state.isLoading} data={state} change={handleItemChange} changeAll={handleItemsChange} reloadAll={handleBackendConfirm} reloadHeaderStatus={reloadHeaderStats} saveDraft={saveDraft}  setRefresh = {setRefresh} SessionCustomerList ={Sessionlist} addSessionCustomer={setSessionCustomer} session={sessionAlert} />}
          {currentTab === 'overview' && <Overview setRoutesSelected={setRoutesSelected} data={state} change={handleBackendConfirm} isLoading={setIsLoading} reloadHeaderStatus={reloadHeaderStats} autoSaveState={autoSaveState} generateReleaseData={generateReleaseData} saveReleaseDraftSaveState={saveDraft}  addSessionCustomer={setSessionCustomer} session={sessionAlert} setRefresh = {setRefresh} />}   
          {currentTab === 'release' && <Release setRoutesSelected={setRoutesSelected} data={state} change={handleBackendConfirm} updateCS={handleCSUpdate} autoSaveState={autoSaveState} saveAutoSavedState={saveAutoSaveState} bufferValues={bufferValue} saveReleaseDraftSaveState={setReleaseDraftSaveState} saveReleaseDraftState={setReleaseDraftState} clearDraft={clearDraft} addSessionCustomer={setSessionCustomer} session={sessionAlert} setRefresh = {setRefresh}  />}   
      </Container>
      
    </ResponsiveDrawer>

  );
}

